import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useAxios from '$hooks/useAxios';
import computeYearsOfExperience from '$utils/computeYearsOfExperience';
import { GET_SHARE } from '$api/endpoints';
import { jobInterestsDefaultValue } from '$constants/formDefaultValues';
import { getTenantDefaultFee } from '$constants/SimeraOperations';
import SPKCandidateList from '$components/SPKCandidateList/SPKCandidateList';
import sortWorkExperienceFunction from '$utils/sortWorkExperience';
import SPKShareTitle from '$components/Share/SPKShareTitle';
import { useSyncCurrencyFromUrl } from '$hooks/useSyncCurrencyFromUrl';

import Spinner from '../../Spinner/Spinner';
import classes from './SharePosition.module.css';

const SharePosition = () => {
  const { shareReferenceId } = useParams();
  useSyncCurrencyFromUrl();
  const [positionData, setPositionData] = useState<any>(undefined);
  const { data, isLoading, error } = useAxios(
    GET_SHARE(shareReferenceId as string)
  );

  const positionTitle =
    positionData?.CustomJobTitle || positionData?.JobPosition?.Title;

  useEffect(() => {
    if (data) {
      const formattedData = { ...data };
      formattedData.CandidatesPositionStatus =
        data?.CandidatesPositionStatus?.map((singleCandidate: any) => {
          singleCandidate.Candidate.YearsOfExperience =
            computeYearsOfExperience(
              singleCandidate.Candidate.CandidateWorkExperience
            );

          if (!singleCandidate.Candidate.CandidateJobInterest) {
            singleCandidate.Candidate.CandidateJobInterest = {
              SalaryLowerBound: jobInterestsDefaultValue.Salary[0],
              SalaryUpperBound: jobInterestsDefaultValue.Salary[1],
            };
          }

          singleCandidate.Candidate.CandidateSkills =
            singleCandidate?.Candidate.CandidateSkills?.map(
              ({ Skill, ...rest }: any) => {
                return { ...rest, Skill: { ...Skill, title: Skill.Title } };
              }
            );

          singleCandidate.Candidate.CandidateWorkExperience =
            singleCandidate.Candidate.CandidateWorkExperience?.sort(
              sortWorkExperienceFunction
            );
          return {
            ...singleCandidate.Candidate,
            Highlight: singleCandidate.Highlight,
          };
        })
          // Sort by Highlight (true first)
          .sort((a: any, b: any) => {
            return (Number(b.Highlight) || 0) - (Number(a.Highlight) || 0);
          });
      setPositionData(formattedData);
    }
  }, [data, setPositionData]);

  return (
    <div
      className="max-w-screen-2xl w-full mx-auto"
      data-testid="candidatePositionPage"
    >
      <div className="flex gap-4 flex-col pb-8">
        {isLoading && (
          <div className={classes.spinner}>
            <Spinner height="100%" width="100%" />
          </div>
        )}
        {error && <div className="m-auto">Invalid Request</div>}

        {!isLoading && positionData && (
          <>
            <SPKShareTitle jobTitle={positionTitle} />
            <SPKCandidateList
              candidates={positionData.CandidatesPositionStatus}
              shareReferenceId={shareReferenceId}
              hideBottomButtons
              feeAmount={
                positionData.FeeAmount ??
                getTenantDefaultFee(positionData.Tenant?.Name)
              }
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SharePosition;
